import { Form, Input, Select } from "antd";

export default ({ serviceTypes }) => {
  return [
    {
      label: "Бодисын нэр",
      name: "name",
      rules: [{ required: true, message: "Нэр оруулна уу!" }],
      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: {
        className: "w-full",
      },
    },

    {
      label: "Төхөөрөмж",
      name: "serviceTypeId",
      type: "select",
      rules: [{ required: true, message: "Төхөөрөмж сонгоно уу!" }],
      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: {
        className: "w-full",
        options: serviceTypes,
      },
    },
    {
      label: "Үнэ",
      name: "price",
      type: "price",
      // rules: [{required: true, message: 'Төрсөн огноо сонгоно уу!'}],
      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: {
        className: "w-full",
      },
    },
    {
      label: "Дэлгэрэнгүй мэдээлэл",
      name: "note",
      type: "textarea",
      // rules: [{required: true, message: 'Төрсөн огноо сонгоно уу!'}],
      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: {
        className: "w-full",
      },
    },
  ];
};
